import React from 'react';
import CSelect, { Error } from 'src/components/form/Select';
import { ActionMeta, Props } from 'react-select';
import _ from 'lodash';

import { EventCompletionStatus } from 'src/graphql/_generated';
import { eventCompletionStatusOptions } from 'src/api/types';

interface EventCompletionStatusSelectProps extends Omit<Props, 'value' | 'options'> {
  value: EventCompletionStatus | undefined | null;
  onChange: (value: { label: string; value: EventCompletionStatus }, meta: ActionMeta<any>) => void;
  onBlur?: () => void;
  error?: boolean;
  helperText?: string | false;
  disabled?: boolean;
  placeholder?: string;
}

export const EventCompletionStatusSelect: React.FC<EventCompletionStatusSelectProps> = ({
  value,
  onChange,
  onBlur,
  error,
  helperText,
  disabled,
  placeholder = 'Select',
  ...rest
}) => {
  return (
    <>
      <CSelect
        isDisabled={disabled}
        value={_.find(eventCompletionStatusOptions, (o) => o.value === value)}
        placeholder={placeholder}
        options={eventCompletionStatusOptions}
        onChange={onChange}
        onBlur={onBlur}
        inputId="completion-status-select"
        {...rest}
      />
      {error && helperText && <Error>{helperText}</Error>}
    </>
  );
};
